(function () {
  if (window.freeShippingWidgetLoaded) return;
  window.freeShippingWidgetLoaded = true;

  const THRESHOLD_DKK = 1100;
  const THRESHOLD_EUR = 395;
  const hostEU = location.hostname.endsWith('.eu');
  const pathEN = location.pathname.startsWith('/en');
  const lang = pathEN ? 'en' : 'da';
  const currency = hostEU ? 'EUR' : 'DKK';

  const money = (v) =>
    new Intl.NumberFormat(lang === 'da' ? 'da-DK' : 'en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: lang === 'da' ? 2 : 0,
      maximumFractionDigits: lang === 'da' ? 2 : 0
    }).format(v);

  function calcCartValues(cart) {
    let subtotal = 0;
    let qty = 0;

    if (Array.isArray(cart.items)) {
      const valid = cart.items.filter((item) => {
        const title = (item.product_title || item.title || '').toLowerCase();
        return !title.includes('leveringsgebyr');
      });

      subtotal = valid.reduce((sum, i) => sum + i.final_line_price, 0) / 100;
      qty = valid.reduce((cnt, i) => cnt + i.quantity, 0);
    } else {
      subtotal = (cart.items_subtotal_price || 0) / 100;
      qty = cart.item_count || 0;
    }

    return { subtotal, qty };
  }

  function render(widget, subtotal, qty) {
    const threshold = hostEU ? THRESHOLD_EUR : THRESHOLD_DKK;
    const missAmt = Math.max(0, threshold - subtotal);
    const missQty = Math.max(0, 3 - qty);
    const qualifies = subtotal >= threshold || qty >= 3;

    const bar = widget.querySelector('.progress-fill');
    const text = widget.querySelector('.free-shipping-message');
    const barWrap = widget.querySelector('.progress-bar');
    if (!bar || !text || !barWrap) return;

    bar.style.width = qualifies ? '100%' : `${Math.min(100, (subtotal / threshold) * 100)}%`;
    barWrap.style.display = qty === 0 ? 'none' : 'block';

    if (qualifies) {
      text.textContent = hostEU
        ? (lang === 'da' ? 'Du har opnået gratis fragt!' : 'You have qualified for free shipping!')
        : (lang === 'da' ? 'Du har opnået fragt for kun 29 DKK' : 'You have unlocked shipping for only 29 DKK');
    } else if (qty === 0) {
      text.textContent = hostEU
        ? (lang === 'da'
            ? 'Gratis fragt ved køb over 395 EUR eller v/3 produkter'
            : 'Free shipping over 395 EUR or with 3 products')
        : (lang === 'da'
            ? 'Billig fragt over 1.100,00 DKK eller v/3 produkter'
            : 'Cheap shipping over 1,100.00 DKK or with 3 products');
    } else {
      const qtyText = lang === 'da'
        ? `${missQty} ${missQty === 1 ? 'produkt' : 'produkter'}`
        : `${missQty} ${missQty === 1 ? 'product' : 'products'}`;

      text.textContent = hostEU
        ? (lang === 'da'
            ? `Du er ${money(missAmt)} eller ${qtyText} fra at opnå gratis fragt`
            : `You are ${money(missAmt)} or ${qtyText} away from free shipping`)
        : (lang === 'da'
            ? `Du er ${money(missAmt)} eller ${qtyText} fra at få billig fragt`
            : `You are ${money(missAmt)} or ${qtyText} away from cheap shipping`);
    }
  }

  function updateWidgets(cart) {
    try {
      const { subtotal, qty } = calcCartValues(cart);
      document.querySelectorAll('.free-shipping-widget').forEach((w) =>
        render(w, subtotal, qty)
      );

      const cartCount = document.querySelectorAll('[data-cart-count]');
      if (cartCount.length > 0) {
        const realQty = cart.items
          .filter(item => !(item.product_title || '').toLowerCase().includes('leveringsgebyr'))
          .reduce((sum, item) => sum + item.quantity, 0);

        cartCount.forEach(el => {
          el.textContent = realQty;
          el.setAttribute('data-cart-count', realQty);
        });
      }
    } catch (err) {
      console.error('[FSW] update error', err);
    }
  }

  let cartPromise = null;
  function fetchCart() {
    if (!cartPromise) {
      cartPromise = fetch('/cart.js')
        .then((r) => r.json())
        .catch((e) => console.error('[FSW] fetchCart error', e))
        .finally(() => (cartPromise = null));
    }
    return cartPromise;
  }

  async function refresh() {
    const cart = await fetchCart();
    if (cart) {
      await removeDeliveryFeeIfAlone(cart);
      window.dispatchEvent(new CustomEvent('cm:cart', { detail: cart }));
    }
  }

  async function removeDeliveryFeeIfAlone(cart) {
    const deliveryItem = cart.items.find(item =>
      (item.product_title || '').toLowerCase().includes('leveringsgebyr')
    );

    const visibleItems = cart.items.filter(item =>
      !(item.product_title || '').toLowerCase().includes('leveringsgebyr')
    );

    if (deliveryItem && visibleItems.length === 0) {
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: deliveryItem.key, quantity: 0 })
        });

        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            note: '',
            attributes: { 'Leveringsdato': '' }
          })
        });

        const dateInput = document.querySelector('[name="note"]');
        if (dateInput) dateInput.value = '';

        document.dispatchEvent(new Event('theme:cart:change'));
      } catch (err) {
        console.error('[FSW] Fejl ved fjernelse af Leveringsgebyr / Leveringsdato', err);
      }
    }
  }

  document.querySelectorAll('.free-shipping-widget').forEach((w) => {
    const subtotal = +w.dataset.subtotal || 0;
    const qty = +w.dataset.qty || 0;
    render(w, subtotal, qty);
    refresh();
  });

  window.addEventListener('cm:cart', (e) => updateWidgets(e.detail));
  document.addEventListener('theme:cart:change', refresh);
  document.addEventListener('theme:cart-drawer:open', refresh);

  document.body.addEventListener('submit', (e) => {
    if (e.target.matches('form[action^="/cart/add"]')) {
      setTimeout(refresh, 250);
    }
  });
})();